// extracted by mini-css-extract-plugin
export default {"qr_partners":"newHdm_qr_partners__5mTzp","qr_qr":"newHdm_qr_qr__T2PfA","phone_pay_content":"newHdm_phone_pay_content__004WB"};